import $ from 'jquery'

import * as Model from 'api/model'
import PoziAPISearch from 'api/search'
import * as PoziUtils from 'api/utils'

/**
 * Pozi MDL Drawer Adapter for Search tab
 */
export default function PoziDrawerTabSearch () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    },
    hide: function (evt) {
      return hide(evt)
    }
  }

  /**
   * Init
   */
  var init = function () {
    console.log('Init search drawer tab.')

    const initialRun = Model.get('app.search.initrun', false) // Hack to get into react wrapper... TOOD: convert all this search stuff to react components.

    const showSearchBox = Model.get('config.layout.map.buttons.search.visible', true)
    if (!showSearchBox) {
      hide()
    }

    const searchableLayers = PoziUtils.getLayersSearchable()
    if (!searchableLayers || searchableLayers.length === 0) {
      console.log('Unable to find any searchable layers.')
      hide()
      return
    }

    $('.pozi-drawer-search-tools').children().remove()

    if (searchableLayers.length <= 1) {
      $('.pozi-drawer-search-tools').hide()
    }

    if (!initialRun) {
      $('#submitButton,.pozi-drawer-tabs-search-icon').on('click', (evt) => {
        PoziUtils.eventHandled(evt)
        PoziAPISearch().search()
      })

      Model.on('app.drawer.activetabid', function PoziDrawerTabSearchOnAppDrawerActiveTabID (value) {
        if (value === 'search') {
          console.log('activetabid changed to search: Update search')
        }
      })
    }

    Model.set('app.search.initrun', true)
  }

  /**
   * Hides tab and adjusts some css
   */
  var hide = function (evt) {
    $('.search').hide()
    $('#search-input-dummy').hide()
    $('#pozi-search-icon-dummy').hide()
    $('#search-input-icon-dummy').hide()
    $('#pozi-drawer-tabs-button-search').hide()
    // TODO: Probably need a more robust tab manager. If there are multiple tabs removed what happens?
    $('.pozi-drawer-tabs').addClass('pozi-drawer-tabs-no-search')
    $('.pozi-drawer-tabs-no-search').removeClass('pozi-drawer-tabs')
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
